//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'

export default {
  name: 'rb-eyewear-protection-modal',

  components: {
    RbModal,
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
  },
}
